import { Button } from "nq-component";
import { upsertUseCase } from "../../../../usecases/object";

const defaultProps = {
  keys: [],
};

const upsertUserCase = () => {
  return upsertUseCase();
};

const handleStatusClick = (object, refetch, collection) => async (update) => {
  try {
    const updateStatus = { ...object, status: update };
    await upsertUserCase().execute(collection.collection, updateStatus);
    refetch();
  } catch (error) {
    console.error("Error Status: ", error);
  }
};

function OutputString({ field, object, keys, refetch, collection }) {
  let value = object[field];
  if (value && typeof value !== "object") {
    const isActive = value === "active";
    const isInActive = value === "inactive";
    const isGood = [
      "good",
      "done",
      "approved",
      "awarded",
      "online",
      "with pay",
      "without pay",
      "printed",
    ].includes(String(value).toLowerCase().trim());
    const isListed =
      value === "Enroll" ||
      value === "Enrolled" ||
      value === "Forwarded to CEBS";

    const isBad = ["bad", "cancelled", "rejected", "disapproved"].includes(
      String(value).toLowerCase().trim(),
    );

    const newValue = value === "New";

    const ongoing = [
      "ongoing",
      "in-progress",
      "pending",
      "cancel request",
      "recommending for approval",
      "recommending for disapproval",
      "for compliance",
      "for hrms processing",
      "for processing",
      "offline",
    ].includes(String(value).toLowerCase().trim());

    const getStatusStyles = (isGood, isListed, isBad, ongoing, newValue) => {
      if (isGood) {
        return {
          border: "1px solid green",
          backgroundColor: "#d7e3d1",
          whiteSpace: "nowrap",
          color: "green",
        };
      }
      if (isListed) {
        return {
          border: "1px solid blue",
          backgroundColor: "#edf5fe",
          whiteSpace: "nowrap",
          color: "blue",
        };
      }
      if (isBad) {
        return {
          border: "1px solid red",
          whiteSpace: "nowrap",
          backgroundColor: "#eacccc",
          color: "red",
        };
      }
      if (ongoing) {
        return {
          border: "1px solid orange",
          whiteSpace: "nowrap",
          backgroundColor: "#fef4e8",
          color: "orange",
        };
      }
      if (newValue) {
        return {
          border: "1px solid black",
          whiteSpace: "nowrap",
          backgroundColor: "#e5e5e5",
          color: "black",
        };
      }
      return {};
    };

    // concat agency
    // if (field === "agency") {
    //   value = `${object.code || ""}${object.agency || ""}`;
    // }
    if (["surname", "Firstname", "Middlename"].includes(field)) {
      value = value.toUpperCase();
    }
    if (field === "qualification" || field === "description") {
      value = value.replace(/\n/g, "<br />");
    }

    if (field === "status" && (isActive || isInActive)) {
      return (
        <Button
          onClick={
            isActive
              ? () => handleStatusClick(object, refetch, collection)("inactive")
              : isInActive
                ? () => handleStatusClick(object, refetch, collection)("active")
                : null
          }
          className="btn btn-outline-primary btn-sm fs-xs shadow-none mybtn"
        >
          <i
            className={
              isActive
                ? "bi bi-toggle-on"
                : isInActive
                  ? "bi bi-toggle-off"
                  : null
            }
          />
        </Button>
      );
    } else if (
      (field === "type" || field === "stats" || field === "status") &&
      (isGood || isListed || isBad || newValue || ongoing)
    ) {
      return (
        <div className="d-flex">
          <span
            style={{
              ...getStatusStyles(isGood, isListed, isBad, ongoing, newValue),
              borderRadius: "5px",
              padding: "2px 10px",
            }}
          >
            {value}
          </span>
        </div>
      );
    }
    return (
      <div
        style={{ width: field === "remarks" && "20rem" }}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    );
  }

  const values = [];
  keys.forEach((key) => {
    const v = object[key];
    if (v && typeof v !== "object") {
      values.push(v);
    }
  });
  return values.join(" ");
}

OutputString.defaultProps = defaultProps;

export default OutputString;
